// Header.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogoImg, StyledHeader, UserName, LogoutButton  } from '../styles/headerStyles'; 
import logoRS from './img/logoRS.png';

const Header = () => {
  const navigate = useNavigate();
  const userName = localStorage.getItem('userName');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userName');
    navigate('/login');
  };

  return (
    <StyledHeader>
      <UserName>Welcome, {userName}</UserName>
      <LogoImg src={logoRS}  alt="Logo" />
      <LogoutButton onClick={handleLogout}>Logout</LogoutButton>
    </StyledHeader>
  );
};

export default Header;
